export enum DocumentManagementTab {
  all,
  recent,
  credit,
}
